import React from "react";

// Navigation
import { NavLink } from "react-router-dom";

// Material UI
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
// redux
import { connect } from "react-redux";
import { signOut } from "redux/actions/auth";
import { Avatar } from "@material-ui/core";

import AvtarImage from "assets/images/avatar.jpg";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import arnoldLogo from "assets/svg/arnold_logo.svg"
import plebgraphLogo from "assets/svg/plebgraph_logo_2.svg"

const RightSideDrawer = ({ signOut, user }) => {
  const [open, setOpen] = React.useState(false);
  const handleToggle = () => {
    // closeSideDrawer();
    setOpen((prevOpen) => !prevOpen);
  };

  let user_details = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user"))  : "";
  const logoHandler = () =>{

    switch (user_details?.role_reference_number) {
      case process.env.REACT_APP_FINANCIER_ARNOLD_ROLE_REFERENEC_NUMBER:
       return <div>
          <div className="arnold_logo">
            <Avatar
            className="avatar_style"
            alt="Remy Sharp"
            src={arnoldLogo}
            />
          </div> 
            <div> 
            <p  className="arnold_role_style">Arnold holdings ltd</p>
          </div>
        </div>
      case process.env.REACT_APP_FINANCIER_PLEBGRAPH_ROLE_REFERENEC_NUMBER:
        return <Avatar
        className="plebgraph_logo"
        alt="Remy Sharp"
        src={plebgraphLogo}
        />     
      default:
        return  <Avatar
          className="float-right avatar_style"
          alt="Remy Sharp"
          src={AvtarImage}
        /> 
    }
  }


  return (
    <>
      <div className="float-right">
        <Button onClick={handleToggle} color="inherit">
          <div style={{ textTransform: "capitalize", paddingTop: "0.8125rem" }}>
            <p className="user_name_style">{user.name}</p>
            <p className="user_role_style">{user.role}</p>
          </div>
          <KeyboardArrowDownIcon className="px-1 opacity-50" />
          {logoHandler()}
        </Button>
      </div>
      <Drawer anchor="right" open={open} onClose={handleToggle}>
        <div style={{ width: 200 }}>
          <ListItem button component={NavLink} to="/">
            <ListItemText primary="My Profile" />
          </ListItem>
          <ListItem button onClick={(_) => signOut()}>
            <ListItemText primary="Logout" />
          </ListItem>
          <span className="absolute bottom-0 pl-2">
            Version : {process.env.REACT_APP_VERSION}
          </span>
        </div>
      </Drawer>
    </>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

const mapDispatchToProps = {
  signOut: signOut,
};

export default connect(mapStateToProps, mapDispatchToProps)(RightSideDrawer);
